import {
	GET_NOTIFICATION,
	UPDATE_NOTIFICATION,
	UPDATE_NOTIFICATION_SUCCESS,
	UPDATE_NOTIFICATION_FAILED,
	GET_NOTIFICATION_SUCCESS,
	GET_NOTIFICATION_FAILED,
	CHANGE_PASSWORD,
	CHANGE_CASE_MODE_REQUEST_SUCCESS,
	CHANGE_PASSWORD_SUCCESS,
	CHANGE_PASSWORD_FAIL,
	CHANGE_PASSWORD_RESET,
} from "../types"

export const getNotification = (data) => ({
	type: GET_NOTIFICATION,
	payload: data,
})

export const getNotificationSuccess = (data) => ({
	type: GET_NOTIFICATION_SUCCESS,
	payload: data,
})

export const getNotificationFailed = (data) => ({
	type: GET_NOTIFICATION_FAILED,
	payload: data,
})

export const updateNotification = (data) => ({
	type: UPDATE_NOTIFICATION,
	payload: data,
})

export const updateNotificationSuccess = (data) => ({
	type: UPDATE_NOTIFICATION_SUCCESS,
	payload: data,
})

export const updateNotificationFailed = (data) => ({
	type: UPDATE_NOTIFICATION_FAILED,
	payload: data,
})

export const changePassword = (data) => ({
	type: CHANGE_PASSWORD,
	payload: data,
})

export const changePasswordSuccess = (data) => ({
	type: CHANGE_PASSWORD_SUCCESS,
	payload: data,
})

export const changePasswordFailed = (data) => ({
	type: CHANGE_PASSWORD_FAIL,
	payload: data,
})

export const changePasswordReset = (data) => ({
	type: CHANGE_PASSWORD_RESET,
	payload: data,
})
